module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 product-info"
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "30px",
      "font-size": "30px"
    }
  }, [_vm._v("\n        Godstransport\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n        Godstransport mellem Fyn og Ærø\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n        Godstransport efter dine behov\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er eksperter i godstransport mellem Fyn og Ærø. Vi varetager hver dag transport for et hav af glade kunder, og vi vil også gerne hjælpe dig. En godstransport dækker over transport og flytning af varer og produkter i alskens kategorier, lige fra letgods, tungt gods, volumen gods, farligt gods, stykgods og pallegods fra A til B.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Alle vores kunder er forskellige og har forskellige behov. Derfor sammensætter vi en unik fragt og logistik løsning, som passer til dit behov, uanset om du har brug for godstransport fra din egen virksomhed, eller en fra en tredjepart. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder dig godstransport, som passer til dine behov og altid til konkurrencedygtige priser.\n    ")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "15px",
      "font-size": "16px"
    }
  }, [_vm._v("\n        Godstransport privat/erhverv\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du en hurtig og personlig service af erfarne chauffører, der kender deres opgaver. Vi lægger stor vægt på god relation til vores kunder, da vi mener at gode relationer er forbundet med en stor grad af troværdighed. Vi lover aldrig mere end hvad vi kan stå indenfor, og vi tilbyder vores ydelser til såvel store -, som små private virksomheder.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi ønsker et partnerskab med vores kunder, hvor begge parter drager nytte af hinanden – så det bliver en win win situation. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sætter en dyd i yde den bedste service, hvor vi ved at alle kunder er forskellige. Vores medarbejdere står klar til at hjælpe dig, så de kender præcis dine /jeres behov. Vælger du Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du ikke alene en effektiv løsning der matcher dine ønsker. Du får chauffører som tager ejerskab ved at udføre et kvalitetsarbejde –for på den måde at bevare et tæt samarbejde langt ud i fremtiden.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "15px",
      "font-size": "16px"
    }
  }, [_vm._v("\n        Godstransport med fragtbil\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø skræddersyer transportløsninger til dig eller din virksomhed. Vælger du os til at transportere dit gods, får du en professionel samarbejdspartner med solid erfaring og stor kapacitet, da vores erfarne chauffører er meget effektive og hurtige til at læsse og  losse dine varer.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi kan også tilbyde faste aftaler om dagligt at afhente og fragte dine varer, og hvis tid er vigtig, ringer vi i forvejen og fortæller dig at vi er på vej. Vi har mange typer fragtbiler, som tilgodeser dig som kunde hvis du har en opgave, som kræver noget specielt.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Vi har fragtbiler som både er velegnede til de mindre gader og leverancer, samt større fragtbiler, der er velegnet til kørsel af stort gods. Og overalt hvor vi kører, sørger vi for at vise respekt i lokalsamfundet – og vi lægger stor vægt på at vi er mindst muligt til gene på vejene.\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/stykgods_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/stykgods_2.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan hjælpe dig uanset hvilket gods du skal have transporteret, og vi klarer forsendelser af alt fra 0 kg småpakker til 38 tons.\n        "), _c('br'), _c('br'), _vm._v("\n        Forsendelser afhentet hos en virksomhed, eller indleveret på vores lager i Odense Fyn inden kl. 09:00, leveres samme dag hos modtager på Ærø.\n        "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "background": "#172b43",
      "color": "#fff",
      "margin": "-20px -20px 20px -20px",
      "font-size": "18px",
      "font-weight": "bold",
      "padding-bottom": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n            Vi tilbyder\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Partigods")])]), _vm._v(" "), _c('p', [_vm._v("\n            Skal du eller din virksomhed sende større partier som f. eks. paller, så er det partigods transport I skal vælge. Vi afhenter partiet hos afsender til den aftalte tid, og leverer hos modtager inden for den aftale tid."), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Stykgods")])]), _vm._v(" "), _c('p', [_vm._v("\n            Stykgods er forsendelser på over 20 kg. Stykgods kan sendes enkeltvis, i små portioner eller i større partier og vi håndterer også langgods og farligt gods. Gods kan deles op i 2 typer efter vægt og rumfang. Letgods er primært gods mellem 100 kg og 1000 kg under 53 i rumfang resten benævnes sværgods.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            At fragte stykgods betyder enten at vi afhenter din pakke eller dine varer, og kører dem til et lager eller til en anden fragtbil, som derefter kører den ud til modtager. Eller betyder, at vi henter din pakke eller varer hos en virksomhed, lager eller anden fragtbil og fragter den til hjem til dig på Ærø. Vi gør os stor umage for at din pakke næsten ikke bliver flyttet undervejs – både for at skåne dit gods men også for at undgå skader. Stykgods kan også sendes som ekspresgods, hvis det ønskes.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb440734"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products/stykgods.vue
// module id = 276
// module chunks = 1